import React from "react";

function CheckboxGroup({ label, options, selected, onChange, otherValue, onOtherChange }) {
  const allOn  = options.length > 0 && options.every(o => selected.includes(o));
  const toggle = val => onChange(selected.includes(val) ? selected.filter(v => v !== val) : [...selected, val]);
  const toggleAll = () => onChange(allOn ? selected.filter(s => !options.includes(s)) : [...new Set([...selected, ...options])]);
  const showOther = options.includes('Other') && selected.includes('Other');
  return (
    <div className="checkbox-section">
      <div className="checkbox-section-header">
        {label && <div className="checkbox-section-label">{label}</div>}
        <button className={`btn-select-all${allOn ? ' all-on' : ''}`} onClick={toggleAll}>
          {allOn ? '\u2713 All Selected' : 'Select All'}
        </button>
      </div>
      <div className="checkbox-grid">
        {options.map(opt => (
          <label key={opt} className={`checkbox-item${selected.includes(opt) ? ' checked' : ''}`}>
            <input type="checkbox" checked={selected.includes(opt)} onChange={() => toggle(opt)} />
            {opt}
          </label>
        ))}
      </div>
      {showOther && (
        <div style={{marginTop:8,paddingTop:8,borderTop:'1px solid #e8ddd0'}}>
          <input
            autoFocus
            placeholder="Please describe..."
            value={otherValue||''}
            onChange={e=>onOtherChange && onOtherChange(e.target.value)}
            style={{width:'100%',border:'1.5px solid #c8a84b',borderRadius:8,padding:'9px 12px',fontSize:14,
              fontFamily:'DM Sans,sans-serif',boxSizing:'border-box',outline:'none',background:'#fdf9f5'}}
          />
        </div>
      )}
    </div>
  );
}

export default CheckboxGroup;
